module.exports = __webpack_public_path__ + "static/media/icon-school-report-active.4f7a2c3e.svg";